import React, { useCallback, useEffect, useState } from "react";

import { addNews, getMethodNames, getModuleNames, getTags } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate } from "utils";

import { AdminHead, Button, Col, ErrorBoundary, Form, MainPage, ModalContent, Row, Message as message } from "components";

import { NewsInputs } from "pages/admin/content/components/NewsInputs";

export const NewsAdd = () => {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [methods, setMethods] = useState([]);
  const [modules, setModules] = useState([]);
  const [imageSuccess, setImageSuccess] = useState(false);
  const [imageURL, setImageURL] = useState(false);
  const [content, setContent] = useState("");
  const [showModal, setShowModal] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadTags = useCallback(
    (language) => {
      getTags({
        language,
        signal,
      })
        .then((res) => {
          setTags(res);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [signal]
  );

  const loadMethods = useCallback(() => {
    getMethodNames({
      signal,
    }).then((res) => {
      setMethods(res);
      loadTags();
    });
  }, [signal, loadTags]);

  const loadModules = useCallback(() => {
    getModuleNames({
      signal,
    }).then((res) => {
      setModules(res);
    });
  }, [signal]);

  const complete = (v) => {
    setLoading(true);

    addNews({
      ...v,
      ...{ image: imageURL, content: content, signal },
    })
      .then(() => {
        navigate("/content/news");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadMethods();
    loadModules();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <ErrorBoundary>
        <AdminHead
          description={
            "Add a news post here. A URL will be automatically generated from the title and cannot be changed once saved. Only the first 3 tags are displayed, but all tags are searched."
          }
          link={"/content/news"}
          title={"Add a new news"}
          tooltipText={"Back to news"}
        />
      </ErrorBoundary>
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <ErrorBoundary>
              <NewsInputs
                content={content}
                imageSuccess={imageSuccess}
                imageURL={imageURL}
                methods={methods}
                modules={modules}
                setContent={setContent}
                setImageSuccess={setImageSuccess}
                setImageURL={setImageURL}
                setLoading={setLoading}
                tags={tags}
                reloadTags={loadTags}
              />
            </ErrorBoundary>
            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading} className="margin-right-100">
                    Save
                  </Button>
                  <Button onClick={() => setShowModal(true)} disabled={loading} loading={loading}>
                    Preview content
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <ModalContent visible={showModal} type="article" onCancel={() => setShowModal(false)}>
        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
      </ModalContent>
    </MainPage>
  );
};
